import {createContext} from "react";

const GuideContext = createContext(null);
export default GuideContext